// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"693":"8e9a7b4a","883":"d95d3b68"}[chunkId] + ".chunk.css";
};